export const REDUCER_KEY = 'committedFlights';
